module.exports = __webpack_public_path__ + "static/media/slideBg3.6ccb927b.jpg";